import Footer from "../components/Footer";
import Headers from "../components/Headers";
import OwlCarousel from "react-owl-carousel";
import Loader from "../components/other/Loader";
import { pageRoutes } from "../routes/pageRoutes";
import "owl.carousel/dist/assets/owl.carousel.css";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useNavigate, useLocation } from "react-router";
import { fetchProfile } from "../redux/action/authAction";
import ErrorMessage from "../components/form/ErrorMessage";
import {
  fetchLatLong,
  fetchLocationList,
  selectLocation,
} from "../redux/action/bookingAction";
import {
  getBookingData,
  pipGetAccessToken,
  setBookingData,
} from "../utils/pip";
import GoogleMapCom from "./GoogleMap";
import DateHourInput from "../components/form/DateHourInput";
import moment from "moment";

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isEdit = useLocation()?.state?.isEdit ?? false;
  const [isEditLoaded, setIsEditLoaded] = useState(false);
  const { isLoading } = useSelector((state) => state.authReducer);
  const { Loading, locationList } = useSelector(
    (state) => state.bookingReducer
  );

  const [isErrorValue, setErrorValue] = useState(false);

  const {
    is_return,
    pick_up_location,
    designation,
    pickup_date_time,
    return_pickup_date_time,
    hourly_duration,
    service_type,
    id,
    designation_ltd_long,
    pick_up_ltd_long,
  } = getBookingData() ?? {};
  const [activeTab, setActiveTab] = useState(
    isEdit ? service_type : "point-to-point"
  );

  const [searchLocation, setSearchLocation] = useState(
    isEdit ? pick_up_location : ""
  );
  const [isPickupList, setIsPickupList] = useState(false);
  const [pickupLatLong, setPickupLatLong] = useState(
    isEdit ? pick_up_ltd_long : ""
  );
  const [searchDestinationLocation, setSearchDestinationLocation] = useState(
    isEdit ? designation : ""
  );
  const [destinationLatLong, setDestinationLatLong] = useState(
    isEdit ? designation_ltd_long : ""
  );
  const [isDestinationList, setIsDestinationList] = useState(false);

  const [formData, setFormData] = useState({
    pick_up_location: isEdit ? pick_up_location : "",
    destination: isEdit ? designation : "",
    pickupDateTime: isEdit ? pickup_date_time : "",
    returnTripDateTime: isEdit ? return_pickup_date_time : "",
    duration: isEdit ? hourly_duration : "",
    isReturnTrip: isEdit ? is_return : false,
  });
  const [errors, setErrors] = useState({});

  const options = {
    loop: true,
    margin: 10,
    nav: true,
    center: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 6,
      },
    },
  };

  const options1 = {
    loop: true,
    margin: 40,
    nav: true,
    center: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      992: {
        items: 2,
      },
    },
  };

  useEffect(() => {
    if (!pipGetAccessToken()) {
    } else {
      dispatch(fetchProfile());
    }
  }, []);

  const handleChange = (e, type = "text") => {
    setFormData({
      ...formData,
      [e.target.name]: type == "checkbox" ? e.target.checked : e.target.value,
    });
  };

  const validateForm = () => {
    let errors = {};

    if (!formData?.pick_up_location)
      errors.pick_up_location = "Please enter Pick-up Location.";
    if (activeTab === "point-to-point" && !formData?.destination)
      errors.destination = "Please enter destination.";
    if (!formData?.pickupDateTime)
      errors.pickupDateTime = "Please enter Pick-up Date/Time";
    if (formData?.isReturnTrip && !formData?.returnTripDateTime)
      errors.returnTripDateTime = "Please enter Return trip date/time.";
    if (activeTab === "hourly" && !formData?.duration)
      errors.duration = "Please enter duration.";
    if (activeTab === "hourly") {
      // Check if duration is in the correct format xx:yy
      if (!/^\d{2}:\d{2}$/.test(formData?.duration)) {
        errors.duration = "Please enter duration in the format xx:xx";
      } else {
        // Extract minutes (last two digits) to ensure they are 0–59
        const [hours, minutes] = formData.duration.split(":");
        if (parseInt(minutes, 10) > 59) {
          errors.duration =
            "The minutes should be less than or equal to 59";
        } else if (formData.duration === "00:00") {
          errors.duration = "Duration should not be 00:00";
        }
      }
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      const data = {
        pick_up_location: formData?.pick_up_location,
        pick_up_ltd_long: pickupLatLong,
        designation_ltd_long: destinationLatLong,
        designation: formData?.destination,
        pickup_date_time: formData?.pickupDateTime,
        hourly_duration: formData?.duration,
        service_type: activeTab,
        return_trip: formData?.isReturnTrip,
        return_trip_pickup_date_time: formData?.returnTripDateTime,
        booking_id: isEdit ? id : "",
      };
      const callback = (response) => {
        if (response?.success) {
          setBookingData(response?.data);
          navigate(pageRoutes.statndard);
        }
      };
      dispatch(selectLocation({ payload: data, callback }));
    }
  };

  const handleTabSwitch = (tab) => {
    setErrorValue(false);
    setActiveTab(tab);
    // setFormData({
    //   pick_up_location: "",
    //   destination: "",
    //   pickupDateTime: "",
    //   returnTripDateTime: "",
    //   duration: "",
    //   isReturnTrip: false,
    // });
    setIsPickupList(false);
    setIsDestinationList(false);
    // setSearchDestinationLocation("");
    // setSearchLocation("");
    setErrors({});
  };

  useEffect(() => {
    if (!searchLocation) {
      setIsPickupList(false);
    } else {
      dispatch(fetchLocationList(searchLocation));
    }
  }, [searchLocation]);

  useEffect(() => {
    if (!searchDestinationLocation) {
      setIsDestinationList(false);
    } else {
      dispatch(fetchLocationList(searchDestinationLocation));
    }
  }, [searchDestinationLocation]);

  const getPickupLatLong = (val) => {
    const callback = (response) => {
      if (response?.success) {
        setIsPickupList(false);
        setPickupLatLong(response?.data);
        setSearchLocation(val);
        setFormData({
          ...formData,
          pick_up_location: val,
        });
      }
    };
    dispatch(fetchLatLong({ payload: val, callback }));
  };

  const getDestinationLatLong = (val) => {
    const callback = (response) => {
      if (response?.success) {
        setIsDestinationList(false);
        setDestinationLatLong(response?.data);
        setSearchDestinationLocation(val);
        setFormData({
          ...formData,
          destination: val,
        });
      }
    };
    dispatch(fetchLatLong({ payload: val, callback }));
  };

  useEffect(() => {
    if (isErrorValue == true) {
      validateForm();
    } else {
      setErrorValue(true);
    }
  }, [formData]);

  if (isLoading || Loading) {
    return <Loader />;
  }

  return (
    <div>
      <Headers />
      <section className="px-4" style={{ overflowX: "unset" }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-8 col-lg-7 mb-4 mb-lg-0">
              <div className="">
                <GoogleMapCom
                  pickupLatLong={pickupLatLong}
                  destinationLatLong={destinationLatLong}
                  setPickupLatLong={setPickupLatLong}
                  setDestinationLatLong={setDestinationLatLong}
                  setPickupPlaceName={(val) => {
                    setSearchLocation(val);
                    setFormData({
                      ...formData,
                      pick_up_location: val,
                    });
                  }}
                  setDestinationPlaceName={(val) => {
                    setSearchDestinationLocation(val);
                    setFormData({
                      ...formData,
                      destination: val,
                    });
                  }}
                />
              </div>
            </div>
            <div className="col-xl-4 col-lg-5 mb-4 mb-lg-0">
              <div className="ct_hero_right_side">
                <ul
                  className="nav nav-pills mb-3"
                  id="pills-tab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      type="button"
                      className={`nav-link ${
                        activeTab == "point-to-point" ? "active" : ""
                      }`}
                      onClick={() => handleTabSwitch("point-to-point")}
                    >
                      Point to point
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      type="button"
                      className={`nav-link ${
                        activeTab == "hourly" ? "active" : ""
                      }`}
                      onClick={() => handleTabSwitch("hourly")}
                    >
                      Hourly
                    </button>
                  </li>
                </ul>
                <div className="tab-content" id="pills-tabContent">
                  {activeTab == "point-to-point" ? (
                    <div className="tab-pane fade show active">
                      <form action="">
                        <div className="coolinput">
                          <label htmlFor="pick_up_location" className="text">
                            Pick-up Location
                          </label>
                          <input
                            placeholder="Enter Pick-up Location"
                            id="pick_up_location"
                            name="pick_up_location"
                            onChange={(e) => {
                              setSearchLocation(e.target.value);
                              setIsPickupList(true);
                              setFormData({
                                ...formData,
                                pick_up_location: e.target.value,
                              });
                            }}
                            className="input form-control"
                            value={searchLocation}
                          />
                          <ErrorMessage
                            errors={errors}
                            fieldName={"pick_up_location"}
                            isError={true}
                          />
                          <i className="fa-solid fa-location-dot"></i>
                        </div>
                        <div
                          className={`ct_filter_dropdown ${
                            isPickupList ? " active" : ""
                          }`}
                        >
                          <ul>
                            {locationList?.map((item) => (
                              <li
                                className="ct_pointer_curser"
                                onClick={() => {
                                  getPickupLatLong(item?.description);
                                  validateForm();
                                }}
                              >
                                {item?.description}
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="ct_connection_icon">
                          <img src="../assets/img/connrct_icon.svg" alt="" />
                        </div>
                        <div className="coolinput">
                          <label htmlFor="input" className="text">
                            Destination
                          </label>

                          <input
                            placeholder="Enter Destination"
                            id="destination"
                            name="destination"
                            onChange={(e) => {
                              setSearchDestinationLocation(e.target.value);
                              setIsDestinationList(true);
                            }}
                            className="input form-control"
                            value={searchDestinationLocation}
                          />
                          <ErrorMessage
                            errors={errors}
                            fieldName={"destination"}
                            isError={true}
                          />

                          <i className="fa-solid fa-location-dot"></i>
                        </div>

                        <div
                          className={`ct_filter_dropdown ${
                            isDestinationList ? " active" : ""
                          }`}
                        >
                          <ul>
                            {locationList?.map((item) => (
                              <li
                                className="ct_pointer_curser"
                                onClick={() => {
                                  getDestinationLatLong(item?.description);
                                  validateForm();
                                }}
                              >
                                {item?.description}
                              </li>
                            ))}
                          </ul>
                        </div>

                        <div className="coolinput">
                          <label htmlFor="input" className="text">
                            Pick-up Date / Time
                          </label>
                          <DateHourInput
                            value={formData.pickupDateTime}
                            onChange={(date) => {
                              setFormData({
                                ...formData,
                                pickupDateTime: date?.format(),
                              });
                              validateForm();
                            }}
                            maxDate={
                              formData.returnTripDateTime
                                ? formData.returnTripDateTime
                                : undefined
                            }
                            minDate={new Date()}
                            placeholder="--  Pick-up Date / Time --"
                          />

                          <ErrorMessage
                            errors={errors}
                            fieldName={"pickupDateTime"}
                            isError={true}
                          />
                        </div>
                        <div className="form-check form-check-inline ct_custom_check mt-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="isReturnTrip"
                            id="isReturnTrip"
                            onClick={(e) => handleChange(e, "checkbox")}
                            checked={formData?.isReturnTrip}
                          />
                          <label
                            className="form-check-label ct_fs_16 ct_fw_400"
                            htmlFor="isReturnTrip"
                          >
                            Add a return trip
                          </label>
                        </div>
                        {formData?.isReturnTrip && (
                          <div className="coolinput">
                            <label
                              htmlFor="returnTripDateTime"
                              className="text"
                            >
                              Return Trip Pick-up Date / Time
                            </label>
                            <DateHourInput
                              value={formData.returnTripDateTime}
                              onChange={(date) => {
                                setFormData({
                                  ...formData,
                                  returnTripDateTime: date?.format(),
                                });
                              }}
                              minDate={
                                formData.pickupDateTime
                                  ? formData.pickupDateTime
                                  : undefined
                              }
                              placeholder="-- Return Trip Pick-up Date / Time --"
                            />

                            <ErrorMessage
                              errors={errors}
                              fieldName={"returnTripDateTime"}
                              isError={true}
                            />
                          </div>
                        )}
                        <div
                          className="mt-3"
                          // onClick={() => navigate(pageRoutes.statndard)}
                        >
                          <button
                            type="button"
                            className="ct_green_btn w-100"
                            onClick={handleSubmit}
                          >
                            Let's check price
                          </button>
                        </div>
                      </form>
                    </div>
                  ) : (
                    <div className="tab-pane fade show active">
                      <form>
                        <div className="coolinput">
                          <label htmlFor="input" className="text">
                            Pick-up Location
                          </label>

                          <input
                            placeholder="Enter Pick-up Location"
                            id="pick_up_location"
                            name="pick_up_location"
                            onChange={(e) => {
                              setSearchLocation(e.target.value);
                              setIsPickupList(true);
                            }}
                            className="input form-control"
                            value={searchLocation}
                          />
                          <ErrorMessage
                            errors={errors}
                            fieldName={"pick_up_location"}
                            isError={true}
                          />
                          <i className="fa-solid fa-location-dot"></i>
                        </div>
                        <div
                          className={`ct_filter_dropdown ${
                            isPickupList ? " active" : ""
                          }`}
                        >
                          <ul>
                            {locationList?.map((item) => (
                              <li
                                className="ct_pointer_curser"
                                onClick={() =>
                                  getPickupLatLong(item?.description)
                                }
                              >
                                {item?.description}
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="coolinput">
                          <label htmlFor="duration" className="text">
                            Select Duration (Hr:Min)
                          </label>
                          <input
                            type="text"
                            placeholder="Enter duration"
                            id="duration"
                            name="duration"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                duration: e.target?.value,
                              });
                              validateForm();
                            }}
                            className="input form-control"
                            value={formData?.duration}
                          />

                          <ErrorMessage
                            errors={errors}
                            fieldName={"duration"}
                            isError={true}
                          />
                        </div>

                        <div className="coolinput">
                          <label htmlFor="input" className="text">
                            Pick-up Date / Time
                          </label>
                          <DateHourInput
                            value={formData.pickupDateTime}
                            onChange={(date) => {
                              setFormData({
                                ...formData,
                                pickupDateTime: date?.format(),
                              });
                              validateForm();
                            }}
                            minDate={new Date()}
                            placeholder="--  Pick-up Date / Time --"
                          />

                          <ErrorMessage
                            errors={errors}
                            fieldName={"pickupDateTime"}
                            isError={true}
                          />
                        </div>
                        <div className="mt-3">
                          <button
                            type="button"
                            className="ct_green_btn w-100"
                            onClick={handleSubmit}
                          >
                            Let's check price
                          </button>
                        </div>
                      </form>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="ct_py_100 ct_overflow_x_hdden" id="whychooseus">
        <div className="ct_grid_2">
          <div
            className="ct_left_whychoose_img"
            data-aos="fade-right"
            data-aos-duration="1000"
          >
            <img src="../assets/img/Chofer_newyork.png" alt="" />
          </div>
          <div
            className="ct_why_choose_right"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <span className="ct_sub_head_badge">WHY CHOOSE US</span>
            <h2 className="ct_fs_38 ct_fw_600 ct_mt_32">
              We offer the best experience <br /> with our best deals
            </h2>
            <ul className="mt-5">
              <li>
                <div className="ct_why_choose_icon">
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.9402 2.71001L9.5302 8.32001H7.1202C6.7202 8.32001 6.3302 8.35001 5.9502 8.43001L6.9502 6.03001L6.9902 5.94001L7.0502 5.78001C7.0802 5.71001 7.1002 5.65001 7.1302 5.60001C8.2902 2.91001 9.5902 2.07001 11.9402 2.71001Z"
                      fill="#004225"
                    />
                    <path
                      d="M18.7301 8.58999L18.7101 8.57999C18.1101 8.40999 17.5001 8.31999 16.8801 8.31999H10.6201L12.8701 3.08999L12.9001 3.01999C13.0401 3.06999 13.1901 3.13999 13.3401 3.18999L15.5501 4.11999C16.7801 4.62999 17.6401 5.15999 18.1701 5.79999C18.2601 5.91999 18.3401 6.02999 18.4201 6.15999C18.5101 6.29999 18.5801 6.43999 18.6201 6.58999C18.6601 6.67999 18.6901 6.75999 18.7101 6.84999C18.8601 7.35999 18.8701 7.93999 18.7301 8.58999Z"
                      fill="#004225"
                    />
                    <path
                      d="M12.5195 18.16H12.7695C13.0695 18.16 13.3195 17.89 13.3195 17.56C13.3195 17.14 13.1995 17.08 12.9395 16.98L12.5195 16.83V18.16Z"
                      fill="#004225"
                    />
                    <path
                      d="M18.2902 10.02C17.8402 9.89001 17.3702 9.82001 16.8802 9.82001H7.12023C6.44023 9.82001 5.80023 9.95001 5.20023 10.21C3.46023 10.96 2.24023 12.69 2.24023 14.7V16.65C2.24023 16.89 2.26023 17.12 2.29023 17.36C2.51023 20.54 4.21023 22.24 7.39023 22.45C7.62023 22.48 7.85023 22.5 8.10023 22.5H15.9002C19.6002 22.5 21.5502 20.74 21.7402 17.24C21.7502 17.05 21.7602 16.85 21.7602 16.65V14.7C21.7602 12.49 20.2902 10.63 18.2902 10.02ZM13.2802 16C13.7402 16.16 14.3602 16.5 14.3602 17.56C14.3602 18.47 13.6502 19.2 12.7702 19.2H12.5202V19.42C12.5202 19.71 12.2902 19.94 12.0002 19.94C11.7102 19.94 11.4802 19.71 11.4802 19.42V19.2H11.3902C10.4302 19.2 9.64023 18.39 9.64023 17.39C9.64023 17.1 9.87023 16.87 10.1602 16.87C10.4502 16.87 10.6802 17.1 10.6802 17.39C10.6802 17.81 11.0002 18.16 11.3902 18.16H11.4802V16.47L10.7202 16.2C10.2602 16.04 9.64023 15.7 9.64023 14.64C9.64023 13.73 10.3502 13 11.2302 13H11.4802V12.78C11.4802 12.49 11.7102 12.26 12.0002 12.26C12.2902 12.26 12.5202 12.49 12.5202 12.78V13H12.6102C13.5702 13 14.3602 13.81 14.3602 14.81C14.3602 15.1 14.1302 15.33 13.8402 15.33C13.5502 15.33 13.3202 15.1 13.3202 14.81C13.3202 14.39 13.0002 14.04 12.6102 14.04H12.5202V15.73L13.2802 16Z"
                      fill="#004225"
                    />
                    <path
                      d="M10.6797 14.64C10.6797 15.06 10.7997 15.12 11.0597 15.22L11.4797 15.37V14.04H11.2297C10.9197 14.04 10.6797 14.31 10.6797 14.64Z"
                      fill="#004225"
                    />
                  </svg>
                </div>
                <div>
                  <h4 className="ct_fs_20 ct_fw_600 mb-2">
                    Best price guaranteed
                  </h4>
                  <p className="mb-0 ct_fs_16">
                    Find a lower price? We'll refund you 100% <br /> of the
                    difference.
                  </p>
                </div>
              </li>
              <li>
                <div className="ct_why_choose_icon">
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.0002 14.5C6.99016 14.5 2.91016 17.86 2.91016 22C2.91016 22.28 3.13016 22.5 3.41016 22.5H20.5902C20.8702 22.5 21.0902 22.28 21.0902 22C21.0902 17.86 17.0102 14.5 12.0002 14.5Z"
                      fill="#004225"
                    />
                    <path
                      d="M12 2.5C10.82 2.5 9.74 2.91 8.88 3.6C7.73 4.51 7 5.92 7 7.5C7 8.44 7.26 9.32 7.73 10.07C8.59 11.52 10.17 12.5 12 12.5C13.26 12.5 14.41 12.04 15.29 11.25C15.68 10.92 16.02 10.52 16.28 10.07C16.74 9.32 17 8.44 17 7.5C17 4.74 14.76 2.5 12 2.5ZM14.59 6.96L11.92 9.42C11.74 9.59 11.51 9.67 11.28 9.67C11.04 9.67 10.8 9.58 10.62 9.4L9.39 8.16C9.02 7.79 9.02 7.2 9.39 6.83C9.76 6.46 10.35 6.46 10.72 6.83L11.31 7.42L13.32 5.57C13.7 5.22 14.29 5.24 14.64 5.62C14.99 6.01 14.97 6.61 14.59 6.96Z"
                      fill="#004225"
                    />
                  </svg>
                </div>
                <div>
                  <h4 className="ct_fs_20 ct_fw_600 mb-2">Experience driver</h4>
                  <p className="mb-0 ct_fs_16">
                    Don't have driver? Don't worry, we have many <br />
                    experienced driver for you.
                  </p>
                </div>
              </li>
              <li>
                <div className="ct_why_choose_icon">
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18 2.5H6C4.34 2.5 3 3.83 3 5.47V16.38C3 18.02 4.34 19.35 6 19.35H6.76C7.56 19.35 8.32 19.66 8.88 20.22L10.59 21.91C11.37 22.68 12.64 22.68 13.42 21.91L15.13 20.22C15.69 19.66 16.46 19.35 17.25 19.35H18C19.66 19.35 21 18.02 21 16.38V5.47C21 3.83 19.66 2.5 18 2.5ZM10.38 13.51C10.79 13.51 11.13 13.85 11.13 14.26C11.13 14.67 10.79 15.01 10.38 15.01H7.7C7.26 15.01 6.85 14.8 6.59 14.44C6.34 14.1 6.28 13.68 6.4 13.28C6.75 12.21 7.61 11.63 8.37 11.11C9.17 10.57 9.62 10.23 9.62 9.65C9.62 9.13 9.2 8.71 8.68 8.71C8.16 8.71 7.75 9.14 7.75 9.66C7.75 10.07 7.41 10.41 7 10.41C6.59 10.41 6.25 10.07 6.25 9.66C6.25 8.32 7.34 7.22 8.69 7.22C10.04 7.22 11.13 8.31 11.13 9.66C11.13 11.07 10.07 11.79 9.22 12.37C8.69 12.73 8.19 13.07 7.94 13.52H10.38V13.51ZM17 13.58H16.79V14.27C16.79 14.68 16.45 15.02 16.04 15.02C15.63 15.02 15.29 14.68 15.29 14.27V13.58H13.33C13.33 13.58 13.33 13.58 13.32 13.58C12.83 13.58 12.38 13.32 12.13 12.9C11.88 12.47 11.88 11.94 12.13 11.52C12.81 10.35 13.6 9.02 14.32 7.86C14.64 7.35 15.25 7.12 15.82 7.28C16.39 7.45 16.79 7.97 16.78 8.57V12.09H17C17.41 12.09 17.75 12.43 17.75 12.84C17.75 13.25 17.41 13.58 17 13.58Z"
                      fill="#004225"
                    />
                    <path
                      d="M15.29 12.08V9.14001C14.7 10.1 14.09 11.13 13.54 12.07H15.29V12.08Z"
                      fill="#004225"
                    />
                  </svg>
                </div>
                <div>
                  <h4 className="ct_fs_20 ct_fw_600 mb-2">
                    24 hour car delivery
                  </h4>
                  <p className="mb-0 ct_fs_16">
                    Book your car anytime and we will deliver it <br />
                    directly to you.
                  </p>
                </div>
              </li>
              <li>
                <div className="ct_why_choose_icon">
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.4704 17.33L18.8604 20.49C18.9604 21.32 18.0704 21.9 17.3604 21.47L13.9004 19.41C13.6604 19.27 13.6004 18.97 13.7304 18.73C14.2304 17.81 14.5004 16.77 14.5004 15.73C14.5004 12.07 11.3604 9.09 7.50038 9.09C6.71038 9.09 5.94038 9.21 5.22038 9.45C4.85038 9.57 4.49038 9.23 4.58038 8.85C5.49038 5.21 8.99038 2.5 13.1704 2.5C18.0504 2.5 22.0004 6.19 22.0004 10.74C22.0004 13.44 20.6104 15.83 18.4704 17.33Z"
                      fill="#004225"
                    />
                    <path
                      d="M13 15.73C13 16.92 12.56 18.02 11.82 18.89C10.83 20.09 9.26 20.86 7.5 20.86L4.89 22.41C4.45 22.68 3.89 22.31 3.95 21.8L4.2 19.83C2.86 18.9 2 17.41 2 15.73C2 13.97 2.94 12.42 4.38 11.5C5.27 10.92 6.34 10.59 7.5 10.59C10.54 10.59 13 12.89 13 15.73Z"
                      fill="#004225"
                    />
                  </svg>
                </div>
                <div>
                  <h4 className="ct_fs_20 ct_fw_600 mb-2">
                    24/7 technical support
                  </h4>
                  <p className="mb-0 ct_fs_16">
                    Have a question? Contact our support <br />
                    any time when you have problem.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section className="ct_py_100 pt-5" id="howitwork">
        <div className="container">
          <div className="row">
            <div
              className="col-md-10 mx-auto"
              data-aos="fade-down"
              data-aos-duration="1000"
            >
              <div className="text-center mb-5">
                <span className="ct_sub_head_badge mx-auto text-center">
                  HOW IT WORK
                </span>
                <h2 className="ct_fs_38 ct_fw_600 ct_mt_32 text-center">
                  Book a Trip in 3 easy steps.
                </h2>
              </div>
              <div className="row">
                <div
                  className="col-md-4 mb-4 mb-md-0"
                  data-aos="fade-right"
                  data-aos-duration="1000"
                >
                  <figure>
                    <div className="ct_book_step_icon ct_why_choose_icon mx-auto">
                      <svg
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M41.2415 17.4C39.1615 8.14 31.0815 4 24.0015 4C24.0015 4 24.0015 4 23.9815 4C16.9215 4 8.86145 8.14 6.76145 17.38C4.40145 27.7 10.7215 36.44 16.4415 41.96C18.5615 44 21.2815 45.02 24.0015 45.02C26.7215 45.02 29.4415 44 31.5415 41.96C37.2615 36.44 43.5815 27.72 41.2415 17.4ZM30.5615 19.06L22.5615 27.06C22.2615 27.36 21.8815 27.5 21.5015 27.5C21.1215 27.5 20.7415 27.36 20.4415 27.06L17.4415 24.06C16.8615 23.48 16.8615 22.52 17.4415 21.94C18.0215 21.36 18.9815 21.36 19.5615 21.94L21.5015 23.88L28.4415 16.94C29.0215 16.36 29.9815 16.36 30.5615 16.94C31.1415 17.52 31.1415 18.48 30.5615 19.06Z"
                          fill="#004225"
                        />
                      </svg>
                    </div>
                    <figcaption className="text-center">
                      <h5 className="ct_fs_20 ct_fw_600">Choose location</h5>
                      <p className="ct_text_clr_6D6D6D">
                        Choose your location and find <br />
                        your best car
                      </p>
                    </figcaption>
                  </figure>
                </div>
                <div
                  className="col-md-4 mb-4 mb-md-0"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <figure>
                    <div className="ct_book_step_icon ct_why_choose_icon mx-auto">
                      <svg
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M33.5014 7.12V4C33.5014 3.18 32.8214 2.5 32.0014 2.5C31.1814 2.5 30.5014 3.18 30.5014 4V7H17.5014V4C17.5014 3.18 16.8214 2.5 16.0014 2.5C15.1814 2.5 14.5014 3.18 14.5014 4V7.12C9.10144 7.62 6.48144 10.84 6.08143 15.62C6.04143 16.2 6.52144 16.68 7.08144 16.68H40.9214C41.5014 16.68 41.9814 16.18 41.9214 15.62C41.5214 10.84 38.9014 7.62 33.5014 7.12Z"
                          fill="#004225"
                        />
                        <path
                          d="M40.001 19.6801H8.00098C6.90098 19.6801 6.00098 20.5801 6.00098 21.6801V34.0001C6.00098 40.0001 9.00098 44.0001 16.001 44.0001H32.001C39.001 44.0001 42.001 40.0001 42.001 34.0001V21.6801C42.001 20.5801 41.101 19.6801 40.001 19.6801ZM18.421 36.4201C18.321 36.5001 18.221 36.6001 18.121 36.6601C18.001 36.7401 17.881 36.8001 17.761 36.8401C17.641 36.9001 17.521 36.9401 17.401 36.9601C17.261 36.9801 17.141 37.0001 17.001 37.0001C16.741 37.0001 16.481 36.9401 16.241 36.8401C15.981 36.7401 15.781 36.6001 15.581 36.4201C15.221 36.0401 15.001 35.5201 15.001 35.0001C15.001 34.4801 15.221 33.9601 15.581 33.5801C15.781 33.4001 15.981 33.2601 16.241 33.1601C16.601 33.0001 17.001 32.9601 17.401 33.0401C17.521 33.0601 17.641 33.1001 17.761 33.1601C17.881 33.2001 18.001 33.2601 18.121 33.3401C18.221 33.4201 18.321 33.5001 18.421 33.5801C18.781 33.9601 19.001 34.4801 19.001 35.0001C19.001 35.5201 18.781 36.0401 18.421 36.4201ZM18.421 29.4201C18.041 29.7801 17.521 30.0001 17.001 30.0001C16.481 30.0001 15.961 29.7801 15.581 29.4201C15.221 29.0401 15.001 28.5201 15.001 28.0001C15.001 27.4801 15.221 26.9601 15.581 26.5801C16.141 26.0201 17.021 25.8401 17.761 26.1601C18.021 26.2601 18.241 26.4001 18.421 26.5801C18.781 26.9601 19.001 27.4801 19.001 28.0001C19.001 28.5201 18.781 29.0401 18.421 29.4201ZM25.421 36.4201C25.041 36.7801 24.521 37.0001 24.001 37.0001C23.481 37.0001 22.961 36.7801 22.581 36.4201C22.221 36.0401 22.001 35.5201 22.001 35.0001C22.001 34.4801 22.221 33.9601 22.581 33.5801C23.321 32.8401 24.681 32.8401 25.421 33.5801C25.781 33.9601 26.001 34.4801 26.001 35.0001C26.001 35.5201 25.781 36.0401 25.421 36.4201ZM25.421 29.4201C25.321 29.5001 25.221 29.5801 25.121 29.6601C25.001 29.7401 24.881 29.8001 24.761 29.8401C24.641 29.9001 24.521 29.9401 24.401 29.9601C24.261 29.9801 24.141 30.0001 24.001 30.0001C23.481 30.0001 22.961 29.7801 22.581 29.4201C22.221 29.0401 22.001 28.5201 22.001 28.0001C22.001 27.4801 22.221 26.9601 22.581 26.5801C22.761 26.4001 22.981 26.2601 23.241 26.1601C23.981 25.8401 24.861 26.0201 25.421 26.5801C25.781 26.9601 26.001 27.4801 26.001 28.0001C26.001 28.5201 25.781 29.0401 25.421 29.4201ZM32.421 36.4201C32.041 36.7801 31.521 37.0001 31.001 37.0001C30.481 37.0001 29.961 36.7801 29.581 36.4201C29.221 36.0401 29.001 35.5201 29.001 35.0001C29.001 34.4801 29.221 33.9601 29.581 33.5801C30.321 32.8401 31.681 32.8401 32.421 33.5801C32.781 33.9601 33.001 34.4801 33.001 35.0001C33.001 35.5201 32.781 36.0401 32.421 36.4201ZM32.421 29.4201C32.321 29.5001 32.221 29.5801 32.121 29.6601C32.001 29.7401 31.881 29.8001 31.761 29.8401C31.641 29.9001 31.521 29.9401 31.401 29.9601C31.261 29.9801 31.121 30.0001 31.001 30.0001C30.481 30.0001 29.961 29.7801 29.581 29.4201C29.221 29.0401 29.001 28.5201 29.001 28.0001C29.001 27.4801 29.221 26.9601 29.581 26.5801C29.781 26.4001 29.981 26.2601 30.241 26.1601C30.601 26.0001 31.001 25.9601 31.401 26.0401C31.521 26.0601 31.641 26.1001 31.761 26.1601C31.881 26.2001 32.001 26.2601 32.121 26.3401C32.221 26.4201 32.321 26.5001 32.421 26.5801C32.781 26.9601 33.001 27.4801 33.001 28.0001C33.001 28.5201 32.781 29.0401 32.421 29.4201Z"
                          fill="#004225"
                        />
                      </svg>
                    </div>
                    <figcaption className="text-center">
                      <h5 className="ct_fs_20 ct_fw_600">Pick-up date</h5>
                      <p className="ct_text_clr_6D6D6D">
                        Select your pick up date and <br />
                        time to book your car
                      </p>
                    </figcaption>
                  </figure>
                </div>
                <div
                  className="col-md-4 mb-4 mb-md-0"
                  data-aos="fade-left"
                  data-aos-duration="1000"
                >
                  <figure>
                    <div className="ct_book_step_icon ct_why_choose_icon mx-auto">
                      <svg
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M43.501 16.0002C43.501 16.8202 42.821 17.5002 42.001 17.5002H6.00098C5.18098 17.5002 4.50098 16.8202 4.50098 16.0002C4.50098 15.1802 5.18098 14.5002 6.00098 14.5002H8.04098L8.80098 10.8802C9.52098 7.38016 11.021 4.16016 16.981 4.16016H31.021C36.981 4.16016 38.481 7.38016 39.201 10.8802L39.961 14.5002H42.001C42.821 14.5002 43.501 15.1802 43.501 16.0002Z"
                          fill="#004225"
                        />
                        <path
                          d="M44.3602 27.32C44.0602 24.02 43.1802 20.5 36.7602 20.5H11.2402C4.82017 20.5 3.96017 24.02 3.64017 27.32L2.52017 39.5C2.38017 41.02 2.88017 42.54 3.92017 43.68C4.98017 44.84 6.48017 45.5 8.08017 45.5H11.8402C15.0802 45.5 15.7002 43.64 16.1002 42.42L16.5002 41.22C16.9602 39.84 17.0802 39.5 18.8802 39.5H29.1202C30.9202 39.5 30.9802 39.7 31.5002 41.22L31.9002 42.42C32.3002 43.64 32.9202 45.5 36.1602 45.5H39.9202C41.5002 45.5 43.0202 44.84 44.0802 43.68C45.1202 42.54 45.6202 41.02 45.4802 39.5L44.3602 27.32ZM18.0002 31.5H12.0002C11.1802 31.5 10.5002 30.82 10.5002 30C10.5002 29.18 11.1802 28.5 12.0002 28.5H18.0002C18.8202 28.5 19.5002 29.18 19.5002 30C19.5002 30.82 18.8202 31.5 18.0002 31.5ZM36.0002 31.5H30.0002C29.1802 31.5 28.5002 30.82 28.5002 30C28.5002 29.18 29.1802 28.5 30.0002 28.5H36.0002C36.8202 28.5 37.5002 29.18 37.5002 30C37.5002 30.82 36.8202 31.5 36.0002 31.5Z"
                          fill="#004225"
                        />
                      </svg>
                    </div>
                    <figcaption className="text-center">
                      <h5 className="ct_fs_20 ct_fw_600">Book your car</h5>
                      <p className="ct_text_clr_6D6D6D">
                        Book your car and we will deliver <br />
                        it directly to you
                      </p>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="ct_py_100 pt-0"
        data-aos="fade-down"
        data-aos-duration="1000"
      >
        {/* <OwlCarousel
          className="owl-carousel owl-theme ct_brand_slider"
          {...options}
        >
          <div className="item">
            <div className="ct_brand_img">
              <img src="../assets/img/honda.png" alt="" />
            </div>
          </div>
          <div className="item">
            <div className="ct_brand_img">
              <img src="../assets/img/jaguar.png" alt="" />
            </div>
          </div>
          <div className="item">
            <div className="ct_brand_img">
              <img src="../assets/img/nisaan.png" alt="" />
            </div>
          </div>
          <div className="item">
            <div className="ct_brand_img">
              <img src="../assets/img/volvo.png" alt="" />
            </div>
          </div>
          <div className="item">
            <div className="ct_brand_img">
              <img src="../assets/img/audi.png" alt="" />
            </div>
          </div>
          <div className="item">
            <div className="ct_brand_img">
              <img src="../assets/img/acura.png" alt="" />
            </div>
          </div>
        </OwlCarousel> */}
      </section>
      {/* Intercity Rides Card Grid */}
      <section className="ct_py_100 pt-0" data-aos="fade-down" data-aos-duration="1000">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="ct_fs_48 ct_fw_600 ct_mt_32 text-center">Intercity Rides</h2>
            <p className="ct_fs_20 ct_text_clr_6D6D6D">Skip the airport lines, drop the station crowds. Ride your personal intercity car.</p>
          </div>
          <div className="row g-4 justify-content-center">
            {/* Card 1: New York - Atlantic City */}
            <div className="col-md-6 col-lg-3">
              <div className="ct_intercity_card" style={{backgroundImage: 'url(/assets/img/atlantic_city.png)', backgroundSize: 'cover', borderRadius: '20px', minHeight: '220px', position: 'relative', color: '#fff', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', padding: '24px'}}>
                <div>
                  <div style={{fontSize: '1.5rem', fontWeight: 500}}>New York City <span style={{fontSize: '1.2rem', margin: '0 8px'}}>&rarr;</span> Atlantic City</div>
                  <div style={{fontSize: '1rem', marginTop: 4}}>125 miles &nbsp; | &nbsp; 2h 00m</div>
                </div>
              </div>
            </div>
            {/* Card 2: New York - Philadelphia */}
            <div className="col-md-6 col-lg-3">
              <div className="ct_intercity_card" style={{backgroundImage: 'url(/assets/img/philadelphia.png)', backgroundSize: 'cover', borderRadius: '20px', minHeight: '220px', position: 'relative', color: '#fff', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', padding: '24px'}}>
                <div>
                  <div style={{fontSize: '1.5rem', fontWeight: 500}}>New York City <span style={{fontSize: '1.2rem', margin: '0 8px'}}>&rarr;</span> Philadelphia</div>
                  <div style={{fontSize: '1rem', marginTop: 4}}>95 miles &nbsp; | &nbsp; 1h 45m</div>
                </div>
              </div>
            </div>
            {/* Card 3: New York - Hamptons */}
            <div className="col-md-6 col-lg-3">
              <div className="ct_intercity_card" style={{backgroundImage: 'url(/assets/img/hamptons.png)', backgroundSize: 'cover', borderRadius: '20px', minHeight: '220px', position: 'relative', color: '#fff', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', padding: '24px'}}>
                <div>
                  <div style={{fontSize: '1.5rem', fontWeight: 500}}>New York City <span style={{fontSize: '1.2rem', margin: '0 8px'}}>&rarr;</span> Hamptons</div>
                  <div style={{fontSize: '1rem', marginTop: 4}}>95 miles &nbsp; | &nbsp; 2h 00m</div>
                </div>
              </div>
            </div>
            {/* Card 4: New York - Boston */}
            <div className="col-md-6 col-lg-3">
              <div className="ct_intercity_card" style={{backgroundImage: 'url(/assets/img/boston.png)', backgroundSize: 'cover', borderRadius: '20px', minHeight: '220px', position: 'relative', color: '#fff', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', padding: '24px'}}>
                <div>
                  <div style={{fontSize: '1.5rem', fontWeight: 500}}>New York City <span style={{fontSize: '1.2rem', margin: '0 8px'}}>&rarr;</span> Boston</div>
                  <div style={{fontSize: '1rem', marginTop: 4}}>200 miles &nbsp; | &nbsp; 3h 30m</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="ct_testimonial_bg"
        id="reviews"
        data-aos="fade-down"
        data-aos-duration="1000"
      >
        <div className="text-center mb-5">
          <span className="ct_sub_head_badge mx-auto text-center">REVIEWS</span>
          <h2 className="ct_fs_38 ct_fw_600 ct_mt_32 text-center">
            What people say about us?.
          </h2>
        </div>
        <OwlCarousel
          className="owl-carousel owl-theme ct_testimonial_slider"
          {...options1}
        >
          <div className="item">
            <div className="ct_testimonial_card">
              <div className="ct_testimonial_cnt">
                <h3>
                  5.0 <span>stars</span>
                </h3>
                <ul className="ct_review_stat">
                  <li>
                    <i className="fa-solid fa-star"></i>
                  </li>
                  <li>
                    <i className="fa-solid fa-star"></i>
                  </li>
                  <li>
                    <i className="fa-solid fa-star"></i>
                  </li>
                  <li>
                    <i className="fa-solid fa-star"></i>
                  </li>
                  <li>
                    <i className="fa-solid fa-star"></i>
                  </li>
                </ul>
                <p className="mt-5">
                  "I feel very secure when using EvoGo's services. Your customer
                  care team is very enthusiastic and the driver is always on
                  time."
                </p>
                <div>
                  <h5 className="ct_fs_24 mb-0">Charlie Johnson</h5>
                  <p className="mb-0 ct_fs_14">From New York, US</p>
                </div>
              </div>
            </div>
          </div>
        </OwlCarousel>
      </section>
      <Footer />
    </div>
  );
};

export default Dashboard;
